let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3zbW7")).then(() => parcelRequire('7XBkx'));